'use strict';

import mockData from'./filter-mock-data.json';

export default class Filter {
  constructor() {

    var eventsListing = mockData;

    var locationFullText = {
      "NATIONAL": "National",
      "ACT" : "Australian Capital Territory",
      "NSW" : "New South Wales",
      "NT" : "Northern Territory",
      "QLD": "Queensland",
      "SA": "South Australia",
      "TAS": "Tasmania",
      "VIC": "Victoria",
      "WA": "Western Australia"
    }

    var topicFullText = {
      "people" : "People",
      "practice" : "Practice",
      "pipeline" : "Pipeline",
      "procurement":  "Procurement"
    }

    var typeFullText = {
      "networking" : "Networking",
      "professionaldevelopment" : "Professional Development",
      "futurenet" : "FutureNet"
    }


$(document).ready(function(){

      let urlParameters = false;
      let currentListOfEvents = [];
      let numberOfTilesAlreadyLoaded = 0;


      //Event detail page taxonomy
      if($('.taxonomy').length){
        const fullDescriptionList = Object.assign(topicFullText, typeFullText);
        $('.taxonomy a').each(function(i, ele){
            Object.keys(fullDescriptionList).forEach(key => {
              if(ele.text=== key){
                ele.text = fullDescriptionList[key];
              }
            })
        })
      }

      let $filter  = $('.filter')

      if($('select')){
        (function ($, jQuery) {
                $('select').niceSelect();
          }(jq14, jq14));


      }

      const matchHeights = function(){
        if(true){


          (function ($, jQuery) {
            $('.js-card__image-text').matchHeight({
              byRow: true,
            });

            $('.card__text-inner').matchHeight({
              byRow: true,
               property: 'min-height',
            });

          }(jq14, jq14));


        }

      }

      $(window).on('resize', throttle(matchHeights,100));




      $filter.each(function(i,ele){

          let cardsShown = 9;
          const  numberOfCardsToShow = 9;
          const $cardListing = $(ele).parent().find('.card-listing');
          $cardListing.addClass('js-card-listing');

          var showCardsOnLoad = function (cardListing){

              var animateIn = function(i){
                cardListing.find('.card:nth-child('+ i +')').addClass('-show');
              };




              function showTiles(value, callback){
                for( var i = 1 ; i < numberOfCardsToShow + 1; i++) {

                  (function(i) {
                         var timeToStart = 150 * i;
                         setTimeout(function() {
                             animateIn(i)
                         }, timeToStart);
                      })(i)
                      if(i == numberOfCardsToShow ) {
                        callback();

                      }

                  }
                }

                showTiles(null,matchHeights);
          }

        //load more button click event

        $(ele).parent().find('.js-load-more').on('click', function (e){
          let numberOfCards = currentListOfEvents.length;
          let counter = 0;
                var animateIn = function(i){
                  let imageURL = $cardListing.find('.card:nth-child('+ i +') img').attr('data-src');

                  $cardListing.find('.card:nth-child('+ i +') img').attr('src', imageURL);

                   $cardListing.find('.card:nth-child('+ i +')').addClass('-show');

               };

               function showTiles(value, callback){
                 for( var i = cardsShown ; i < cardsShown+numberOfCardsToShow + 1; i++) {

                   (function(i) {
                          var timeToStart = 150 * counter;
                          setTimeout(function() {
                              animateIn(i)
                          }, timeToStart);
                          counter++;
                       })(i)
                       if(i == cardsShown+numberOfCardsToShow  ) {
                         callback();

                       }

                   }
                 }

                 showTiles(null,matchHeights);


          cardsShown = cardsShown + numberOfCardsToShow;
          if(numberOfCards <= cardsShown) {
            $(this).parent().fadeOut();
          } else {
            $(this).parent().fadeIn();
          }
        })


        const orderByDate = function(arrayItems){
          arrayItems.sort(function(a,b){
            var regex = /-?\d+/;
            var eventADateStart;
            var eventBDateStart;
            if(a.EventStartDateTime){
              eventADateStart = new Date(parseInt(regex.exec(a.EventStartDateTime)[0]));
            }

            if(b.EventStartDateTime){
              eventBDateStart = new Date(parseInt(regex.exec(b.EventStartDateTime)[0]));
            }

            return eventADateStart - eventBDateStart;
          });
        }


        //display tiles

        const displayTiles = function (listOfEvents, startRangeTilesToLoad){
          currentListOfEvents = listOfEvents;
          let numberOfTilesToLoad = 9;
          let cardListing = $(ele).parent().find('.card-listing');


          if(numberOfTilesAlreadyLoaded > 0){
              cardListing.html('');
          }

          if(startRangeTilesToLoad) {
            numberOfTilesAlreadyLoaded = startRangeTilesToLoad;
          }

          orderByDate(listOfEvents);

          $.each(listOfEvents,function(i, ele){
            let { EventBannerImage, EventListingImage, EventName, EventSalesforceLink, EventTypes, EventTopics, EventState, EventStartDateTime, EventLocation, StringifiedDateTime, EventUrl, EventBannerAltText } = ele;

            let imageMarkup = `<img src="${ EventListingImage }" alt="">`;
            if(i > numberOfTilesAlreadyLoaded + numberOfTilesToLoad ) {
                imageMarkup = `<img data-src="${ EventListingImage }" src="" alt="">`
            }


              let date = StringifiedDateTime;
              let tile = `<div class="card card--events"><a href=" ${ EventUrl }" class="card__image">
                  <div class="card__image-wrapper">${imageMarkup}</div>
                  <div class="js-card__image-text card__image-text">
                    <div class="card__text js-date">${ StringifiedDateTime }</div>
                    <div class="card__text">${ EventLocation }</div>
                  </div>
                  <div class="card__text-inner">
                    <div class="card__title">${ EventName }</div>
                  </div>
                  </a>
                <div class="card__text-wrapper">
                  <a href="${ EventSalesforceLink }" class="btn btn--primary">Register</a>
                </div>
              </div>`;

              cardListing.append(tile);

          })

            showCardsOnLoad(cardListing);

            if($cardListing.find('.card').length <= numberOfCardsToShow ) {
              $('.btn__wrapper--center').hide();
            } else {
              $('.btn__wrapper--center').show();
            }

            numberOfTilesAlreadyLoaded += numberOfTilesToLoad
        }

        let APIUrl = $(ele).parent().find('.js-card-listing').attr('data-service-url');
        let listOfEvents;
        let loader = $(ele).parent().find('.js-loader .loader');

        const url = window.location.href;
        const queryString = url ? url.split('?')[1] : window.location.search.slice(1);

        var showUrlParameters = function(filter){
          //on page load  and if there are parameters in the url

          let url= window.location.href;

          url  = url.split('?');
          let query = window.location.search.substring(1);
          let vars = query.split("&");

          const getQueryVariable = function(variable){
            if (url.length > 1 && query[1] !== '') {
              for (var i=0; i<vars.length; i++) {
                 var pair = vars[i].split("=");
                 if (pair[0] == variable) {
                   return pair[1];
                 }
               }
            }
          }

          let location = getQueryVariable("location");

          if(location) {
            let locationKey = location.toLowerCase();
            $(`label[data-value='${ locationKey }']`).trigger( "click" );
          }


          let topic = getQueryVariable("topic");
          if(topic) {
            let topicValue = topic.toLowerCase().replace("_","");;
            filter.find(`label[data-value='${ topicValue }']`).trigger( "click" );

          }


          let type = getQueryVariable("type");
          if(type){
            let typeValue = type.toLowerCase().replace("_","");
            filter.find(`label[data-value='${ typeValue }']`).trigger( "click" );
          }

        }




        let $filterList = $(ele).find('.filter__dropdown-list')
        let $filterDropdown = $filterList.find('.dropdown')
        let $filterTagsList = $(ele).find('.filter__tags');


        var optionsObject = {
          "location": [],
          "topic": [],
          "type": []
        }

        var options = [...optionsObject["location"],...optionsObject["type"],...optionsObject["topic"] ];


        var filterEvents = function (){


            var filteredList1 = listOfEvents.filter(function (el) {
              if(optionsObject["location"].length){

                var locationPresent = false;
                var el = el;
                var eventLocationArray;

                eventLocationArray = el.EventStates;

                $.each(eventLocationArray, function(i,ele){

                  if( optionsObject["location"].indexOf(ele.toLowerCase().replace("_", "")) != -1 ){
                    locationPresent = true;
                  }
                })

                if(locationPresent){
                  return true;
                }

              } else {
                return true;
              }

            });



           var filteredList2 = filteredList1.filter(function (el) {

                 if(optionsObject["topic"].length){

                   var topicPresent = false;
                   var el = el;
                   var eventTopicArray;
                   if(el.EventTopics){
                     eventTopicArray = el.EventTopics;
                   }

                   $.each(eventTopicArray, function(i,ele){


                     if( optionsObject["topic"].indexOf(ele.toLowerCase().replace("_", "")) != -1 ){
                       topicPresent = true;
                     }
                   })

                   if(topicPresent){
                     return true;
                   }

                 } else {
                   return true;
                 }


              });



            var filteredList3 = filteredList2.filter(function (el) {

              if(optionsObject["type"].length){
                var typePresent = false;
                var el = el;
                var eventTypeArray;
                if(el.EventTypes){
                  if( jQuery.type( el.EventTypes ) === "string"){
                    eventTypeArray = [el.EventTypes]
                  } else {
                    eventTypeArray = el.EventTypes;
                  }
                }

                $.each( eventTypeArray, function(i,ele){
                  if( optionsObject["type"].indexOf(ele.toLowerCase().replace("_", "")) != -1 ){
                    typePresent = true;
                  }
                })

                if(typePresent){
                  return true;
                }

              } else {
                return true;
              }

             }
           );


           displayTiles(filteredList3);
           cardsShown = 9;

           if(filteredList3.length <= numberOfCardsToShow) {
             $('.js-load-more').parent().fadeOut();
           } else {
             $('.js-load-more').parent().fadeIn();
           }

           if(filteredList3.length == 0 ) {
             $('.card-listing__message').addClass('-show');
             $('.js-card-listing').fadeOut();
           } else {
             $('.card-listing__message').removeClass('-show');
             $('.js-card-listing').fadeIn();
           }

        }
    //click event for drop down
        $(ele).find( '.dropdown-toggle' ).on( 'click', function( e ) {
          $(this).next().find('label').attr('tabindex', '0');

        })

    //click event for drop down item
        $(ele).find( '.dropdown-menu label' ).on( 'click', function( event ) {

           var $target = $( event.currentTarget ),
              category = $target.parents('.dropdown').find('button.dropdown-toggle').attr('data-value').toLowerCase(),
               val = $target.attr( 'data-value' ).toLowerCase(),
               $inp = $target.find( 'input' ),
               idx;



          if($(this).hasClass('selected')){
            $(this).removeClass('selected');
          } else {
            $(this).addClass('selected');
          }




          if($target.parents('.dropdown-menu').hasClass('dropdown-menu--no-checkbox')){
            $('.dropdown').removeClass('open')
          }


           if ( ( idx = options.indexOf( val+category ) ) > -1 ) {
              options.splice( idx, 1 );
              let index = optionsObject[category].indexOf( val );

              optionsObject[category].splice( index, 1 );


              setTimeout( function() { $inp.prop( 'checked', false ) }, 0);
           } else {

              options.push( val+category );
              optionsObject[category].push( val );

              setTimeout( function() { $inp.prop( 'checked', true ) }, 0);
           }

           $( event.target ).blur();
           $filterTagsList.html('');
           addTags(optionsObject, category);
           filterEvents();
           return false;
        });

        var addTags = function(optionsObject, category){
          for (var key in optionsObject) {
            let value =  optionsObject[key];


            $.each(value,function(i,ele){
              if(key === "location"){
                ele = locationFullText[ele.toUpperCase()];
              } else if (key === "topic") {
                ele = topicFullText[ele];
              } else {
                ele = typeFullText[ele];
              }
              if(ele !== undefined)
              {
                $(`<button class="tag" type="button" data-category="${key}" data-value="${ele}"><span class="sr-only">Remove filter tag: </span>${ele}</button>`).appendTo($filterTagsList);
              }
            })
          }
        }

        $.ajax({
              type: 'GET',
              url: APIUrl,
              dataType: 'json',
              success: function (data) {

                listOfEvents = $.parseJSON(data);
                loader.fadeOut();


                if(queryString){
                  urlParameters = true;
                }

                if(!urlParameters) {
                  displayTiles(listOfEvents);
                } else {
                  showUrlParameters($(ele))
                }
              }
          });

        if (process.env.NODE_ENV === 'development') {
          //dev purposes only
          listOfEvents = $.parseJSON(eventsListing);
          loader.fadeOut();

          if(queryString){
            urlParameters = true;
          }

          if(!urlParameters) {
            displayTiles(listOfEvents);
          } else {
            showUrlParameters($(ele))
          }
        }

        //click event for tags
        $('body').on('click', '.tag', function(event){


          var $target = $( event.currentTarget );
          var targetValue = $target.attr('data-value');
          var category =  $target.attr('data-category').toLowerCase();
          var targetValueUpperCase;
          var targetValueLowerCase;


          if( category === "location") {
            targetValueUpperCase = Object.keys(locationFullText).find(key => locationFullText[key] === targetValue);
            targetValue = targetValueUpperCase.toLowerCase();
          } else if ( category === "type") {
              targetValue = Object.keys(typeFullText).find(key => typeFullText[key] === targetValue);

          } else {
              targetValue = Object.keys(topicFullText).find(key => topicFullText[key] === targetValue);
          }


          var  indexOfItem = options.indexOf(targetValue+category);

              if(indexOfItem != -1){
                options.splice(indexOfItem, 1);
                let index = optionsObject[category].indexOf( targetValue );
                optionsObject[category].splice( index, 1 );

              }

              $(ele).find(`.${category} label[data-value="${ targetValue.toLowerCase() }"] input`).prop( 'checked', false);
              $filterTagsList.html('');
              addTags(optionsObject, category);
              filterEvents();
              $(ele).find(`.${category} label[data-value="${ targetValue }"]`).removeClass('selected');
        })
      })


      if($('.dropdown-menu--no-inputfield').length){
        const radioBtn = $('.dropdown-menu--no-inputfield input[type="radio"]');
        radioBtn.on('focus', function(){
          $(this).parents('label').addClass('focused')
        })
        radioBtn.on('blur', function(){
          $(this).parents('label').removeClass('focused')
        })
      }


})


  }
}
